import { PublicApiClient } from '@guiker/map-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const useMapApiClient = useAuthenticatedApiClient(PublicApiClient)
